/**
 * CheckList — editorial list with a small crimson dot marker.
 * (Reworked from the filled-navy-square "Dummies" bullets.)
 * Used in Bottom Line / cheat-sheet blocks across reads.
 */

export default function CheckList({ items }) {
  return (
    <ul
      style={{ listStyle: "none", margin: "10px 0", padding: 0 }}
      data-component="CheckList"
    >
      {items.map((item, i) => (
        <li
          key={i}
          style={{
            display: "grid",
            gridTemplateColumns: "18px 1fr",
            gap: 12,
            padding: "7px 0",
            alignItems: "start",
          }}
        >
          <div
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "var(--ppr-color-accent-coral)",
              marginTop: 9,
            }}
          />
          <div
            style={{
              fontFamily: "var(--ppr-typography-font-family-body)",
              fontSize: "var(--ppr-typography-font-size-base)",
              lineHeight: "var(--ppr-typography-line-height-loose)",
              color: "var(--ppr-color-text-primary)",
            }}
          >
            {item}
          </div>
        </li>
      ))}
    </ul>
  );
}
